<template>
    <div :class="{'store-file-item':true,'canplay':canplay}">
        <div class="info">
            <div @click="click" class="name">{{file.name}}</div>
            <div class="size">{{showSize(file.size)}}</div>
        </div>
        <slot></slot>
    </div>
</template>
<script>
export default {
    data(){
        return {
            canplay:false
        }
    },
    props:{
        file:{type:Object,default:()=>({name:'',size:0,id:''})}
    },
    watch:{
        file(f){
            this.checkCanplay(f);
        }
    },
    mounted(){
        this.checkCanplay(this.file);
    },
    methods:{
        click(){
            if(this.canplay){
                this.$emit('click:name',this.file);
            }
        },
        checkCanplay(f){
            this.canplay = this.check(f);
        },
        check(file){
            return file.name.match(/\.((mp3)|(flac)|(m4a)|(wav)|(mp4))$/i) != null;
        },
        showSize(size){
            if(size < 1024){
                return size + ' B';
            }else if(size < 1024 * 1024){
                return (size/1024).toFixed(2) + ' KB';
            }else if(size < 1024 * 1024 * 1024){
                return (size/1024/1024).toFixed(2) + ' MB';
            }else if(size < 1024 * 1024 * 1024 * 1024){
                return (size/1024/1024/1024).toFixed(2) + ' GB';
            }else if(size < 1024 * 1024 * 1024 * 1024 * 1024){
                return (size/1024/1024/1024/1024).toFixed(2) + ' TB';
            }
        }
    },
    emits:["click:name"]
}
</script>
<style scoped>
.store-file-item.canplay .info .name{
    text-decoration: underline;
    cursor: pointer;
}
.store-file-item .info .name{
    font-size: 14px;
    font-weight: bolder;
    white-space: nowrap;
    word-break: keep-all;
    width:29vw;
    max-width: 450px;
    overflow: hidden;
    text-overflow: ellipsis;
}
.store-file-item .info .size{
    font-size: 12px;
}
.store-file-item .info{
    margin:auto 0px;
}
.store-file-item.canplay{
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAAXNSR0IArs4c6QAABZBJREFUeF7lm+2LVFUcxz+/nXXnjkkvIpNsmXvXzMAe3gipQaFU2iNkm0Il9CLtWcroEcIHCqInNYyQ3CBo60XlFvSkQSQJlVD/gBntFStK60UP7jV35sS5M1fX2dmZe++cs3uHubAsy57z/f7O956H3znnewXLzwzOP+cEpX4ozxPkbFAzCX+jf2ZW6Y8AR0EdBTmiwt9dB6aR2/UPP/5uM0SxAe7Q50JpGcgtwLUtcuwGNQS5zwN+8lvEGlfdqAAO7hqBmxXcYDpQjSfwiYIPA/wBU/hGBCjg3qJgHbDEVGBNcPYKbB/BH2qVryUBHLwlCrVOQHf1SX8UDAmyPWB4b1ryVAIUOK9X0b0RWJOW2HC9AWF08wg/H06Km1iAAsWVCnkWmJeUzHL5A4J6eoRD7yXhSSRAHneLwPokBJNdVsHW4/iPxOWNLYCD+zWwOC7wFJf7JsC/PE4MsQRwcFUcsKyVCfCbtq9pAQf3beD2rDUuZjzvBPh3NCrbUAAHV1cejEmW1WKrA3z9Eus+EwpQwFuoUN9mtVVJ4hJk0QjD++vVqSvAmfSe9R+5T4GFSYgyXHZ/D6Xr/+Lwn7Ux1hXAwd2ZoSTHlK4DAf7apgLo9BbUl6ZYs4UjS2vT5nE9II+7a6pye9ti6b3Dcfz+sTynCVDd1e2yHchU4gv0j91FniaAg6u7vtEtrUItE+RNYPZUNnwM994Af2n090kB9GEGoCc/o0+UjRXw1ivUFqPg6cHWRocqYwQo7gZZnh6zfs2adLTbwd0B3GWaJxme2hNwKDyqCwXI0ztXyP2QDCRe6Xr5eA/F+V3IG8CieCjmSylKFxzn8MFQgALuYwpeME8DjTYkBdx+BXp+mGGDuxGmwOMj+C+GAjh4X4G6wkYQcXZkDsUNIJtt8E+MKfsChq+U6bjnluEXW+RxBKi8hDlFKL8EaqWtWGpxu2C25HEfEHjVFmlcASL+PMVrBNkGzLcVU4Sr4EHJU9wqyMO2yJIKcEoIuy9G8yjUNnFw3wJWZ00AHY/elZ4gt6l652AjxEFxsLP+R9Gm7QFjW1vAXaxQG83nKWqP7gHfAQtsyKsxTQgQxebg3QlKH8n3Gor3ey3AMOAaAhwHY1KACvhFPQ5/bwJ5ykDMvhbgX2C6AbC6EOYFqND00HuJkNuod3ctxH6sjQXou1QobxJY0aoAbTYEPCePekbg0RYaHlUNh0DbTIJ5vPskXA2YZaDxGkJPgtlfBvP0LdPd3fzVXGUZzGwidAZ9s0rh/sBaojaY2VTYwdsMaoOhrl4XJkyFq+PqNVtESZfBAt5tqpLszLEVU4SrkPtF29hGGf3NFllcAfL0XSiU9a70alux1OJ20z2reiDifmbAzpY6EXLwdoC6Z7IaXuXZHeBfVxWguBbkdRsBNOoBebx7BfWyzUx04japuwMO7awKoI2NZZ0QGX/qCVCg7zJFWR+KXmycMDZgl6eNlyePxQu4H9swOJ4uwIJpDn8MgloVO04LBbXhcgT/Rg09aRcjDt6ToJ6z0J40kOMvRjSKnauxruWC0m89MkanCdhknfpXY5qh4y9HtQgdfT1eGQYdbpCozgWda5GpzAWhGfqLDPqB006GB4TRq+qZqRvY5EJT9LtpGbNUT1CrJjJRNzRKtoM5upnQzczTcayy7WSSrtWjqWm6qQDVSbFzzdKRpG1mmm5qko7aFasHjBGhHczTDc3RtWMkkQCVJTI0Ub+SQR/xfkEemsgUPdFkmVgADVQ1Uz+fIT/xQA+lJ+qZoZutEqkEODUkOvSzuVpVO/bDyVohKm5Tdat5I0PEpPaAvJ+5T2drhdDGyy5yKxRyU+v2O9knqI/KlD7QxsZmYzrp/1uaA+KQaRteKfy0Vs1N9vm8HMzB0DH8X+PwpC3zP97as9yQvPovAAAAAElFTkSuQmCC);
    background-size: 41px 41px;
    background-position-x: 5px;
}
.store-file-item{
    padding:15px 0px;
    padding-left:60px;
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAAXNSR0IArs4c6QAAA2pJREFUeF7tm7trFFEUxn93o+4YCxtBFN1JQLTQQggWQhCjQpoYO0ELwfgPaCGCFloIggiKtopNCtHCB76wMUSxCogS7XQfMYqPQkGzO2r2yoRd3Sxx556dnc1s9m4733l9c86Zew53FcLfEtZuSpAYBHYAO4XiYniBrKoUcnA/gb6nUTc8svfFCqsEZikPUuaQ6gV1FVgXhG3U8zkI0P906zMFcsfD2DImIElqQKGGgeVhDEplaxMAGm55qIOQ+SrV7eONCEjSvUFRfAqsqMdIGJkgAkq6J0H1FshkpLaMCHBwrwBDUuWNwBsSUDKl+gpkRiR2AwlI0tWv0A8lShuJlREwk9QiEgIJcEidAnWykUFJdMkJkJFgQID7DNgqcbqR2PoIMCfBhICKz04jQzPTlYDVU2Q/lNEO7jiw0UD6yzSJXb9Iv6iFjT0BGr3bI3e3HEQS96yCowYE+JBrBbL7WpoAhT6WJ3e2HEQnqZ4iasyQAKpLqFou9hkAjBTI9lU6LmnMC4EA8afNNDuMToIO7rw2Qd9JDTc9pg7A5++S4EywrVAC5VPeqGZ6yGPijUlgppgWImAmpHEND0CPeix6Am+/mQb6P1yrESCOd4E0QXHcfwUsAVUbpVY8B9T/+mFBHIQsAWEYsD3A9oDZa/XImqBC703QMfqD9McwKRsku4zulUWmt2nU9SCs/7wpJRBkxMTRejAmc0qQb6FPgprEHo/0nXoCCCuTpHtQUbxdS0/kBFSvrMIGJZHvxF1VhPeWgBoMRJ4BbV8CJp1WktYSbCyaYNnhtv4MSt5as7GR94BmByS1Zwmws0CTZgFpajYLb0vAloAtgZoDX+hp0B6EDJYOUTW8WByF234YsvuAqjs8UaX7XHpjsRBp+xKw+4BSbtp9QDOLX2DLzgJ2FrCzQOhZ4DGwXVB2MYLqiQK5VC2HAoehJF2HFfp8jKKSuBL+rvBiujZ3oJ9LrMYF61+qzpM9FyoDfGEH9zJwKC6BmfqhKfZ7TDwKTUCJBNN7+qb+RYrT6AseuSNBRgJ7QKUCB3cCWBOkNAbPxwpkt5j4ISKglAkngNMmyucBk9eoSwl+X8zzbtLEvpgAX+lS3P0aBoAeYL2JoQgx/n8FX2t4pUkM/yT9UmKrLgIkBuKOtQTE/Q1F7V/bZ8AfOvN5UPOxuykAAAAASUVORK5CYII=);
    background-repeat: no-repeat;
    background-size: 51px 51px;
    background-position-y: center;
    width:calc(100% - 60px);
    height:51px;
    display: flex;
    justify-content: space-between;
}
</style>